import { createFileRoute, redirect } from '@tanstack/react-router';

import { LoginPage, getCurrentManager } from '../features/auth';

export const Route = createFileRoute('/login')({
  beforeLoad: () => {
    // Уже вошли - незачем показывать форму.
    if (getCurrentManager()) throw redirect({ to: '/dashboard' });
  },
  component: LoginPage,
});
